import Swiper from "swiper";
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const venueShow = (target) => {
  if (target) {
    const show = new Swiper(target, {
      modules: [Autoplay, Pagination],
      loop: true,
      autoplay: {
        delay: 5000
      },

      pagination: {
        el: '.carousel-nav__dots',
        clickable: true
      }
    })
  } else {
    console.warn('Venue Show: No target given')
  }
}

const initShows = () => {
  const venueShowEls = document.querySelectorAll('.js-venue-carousel')
  if (venueShowEls) {
    Array.from(venueShowEls, target => venueShow(target))
  }
}

export { initShows }